import { render, staticRenderFns } from "./Metodics.vue?vue&type=template&id=312ebe32&scoped=true"
import script from "./Metodics.vue?vue&type=script&lang=js"
export * from "./Metodics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312ebe32",
  null
  
)

export default component.exports